import { render, staticRenderFns } from "./Allocations.vue?vue&type=template&id=c48e65c2&scoped=true"
import script from "./Allocations.vue?vue&type=script&lang=ts"
export * from "./Allocations.vue?vue&type=script&lang=ts"
import style0 from "./Allocations.vue?vue&type=style&index=0&id=c48e65c2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c48e65c2",
  null
  
)

export default component.exports